module.exports = __webpack_public_path__ + "img/dataforce-by-seowork.445053e0.svg";